import React from "react";
import { StyleSheet } from "react-native";
import i18n from "@microdoing/shared/i18n";
import AnimatedBox from "app/components/common/AnimatedBox";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { MainText, MainTitle } from "app/components/common";

const styles = StyleSheet.create({
  main: {
    width: widthPercentageToDP("90%"),
    marginBottom: 15,
  },
});

const EndCoachingMessage = ({ endCoachingMessage = "" }) => {
  return (
    <AnimatedBox style={styles.main}>
      <MainTitle>{i18n.t("coach-message")}</MainTitle>
      <MainText fontStyle="italic">{`"${endCoachingMessage}"`}</MainText>
    </AnimatedBox>
  );
};

export default EndCoachingMessage;
